export default __webpack_public_path__ + "static/media/Belt of Courageous Souls.f7c88765.jpg";